export default __webpack_public_path__ + "static/media/AC_5.e663f585.jpg";